import { GlobalStyles } from '@mui/material'
import cropStyle from 'components/UploadImageSection/cropStyle'

function ApplyGlobalStyle() {
    return <GlobalStyles styles={{ ...(cropStyle as any) }} />
}

export default ApplyGlobalStyle
